/**
 * streamlines add a dynamic value to minWidth.
 * @param {object} param0
 * @param {string} param0.$minWidth
 * @returns {string}
 */
const dynMinWidth = ({ $minWidth }) => {
  if ($minWidth === undefined) return "";
  if (typeof $minWidth === "number") return `min-width: ${$minWidth}px;`;
  return `min-width: ${$minWidth};`;
};

export default dynMinWidth;
